import { useSessionStore } from 'stores/sessionStore';
import { useSupportUserStore } from 'stores/supportUserStore';
import { isSupportLoginEmail } from 'utils/supportUsers';

/** Support identity is hydrated before session verification and updated on selection. */
export const useNeedsSupportSelection = (): boolean => {
  const supportAccess = useSessionStore((state) => state.supportAccess);
  const selectedEmail = useSupportUserStore((state) => state.impersonatedEmail);
  return (
    supportAccess && (!selectedEmail || isSupportLoginEmail(selectedEmail))
  );
};
